import { ReactNode, RefObject } from 'react';

import { ListingViewSidebarHolder } from './ListingViewSidebar.styled';

type Props = {
  id?: string;
  children: ReactNode;
  maxWidth?: number;
  withMaxHeight?: boolean;
  qaId?: string;
  holderRef?: RefObject<HTMLElement>;
};

export function ListingViewSidebar({
  id,
  children,
  maxWidth,
  withMaxHeight,
  qaId,
  holderRef,
}: Props) {
  return (
    <ListingViewSidebarHolder
      id={id}
      data-qa-id={qaId}
      $withMaxHeight={Boolean(withMaxHeight)}
      style={{ maxWidth }}
      ref={holderRef}
    >
      {children}
    </ListingViewSidebarHolder>
  );
}
